# Компонент для диаграммы Ганта
# принимает 2 обязаетльных параметра data и rows

# Data это массив наборов данных. Каждый набор имеет следующий вид:
# [
#   name: 'returnedStatus' # название, обязательно
#   typeChart: 'line' # тип данных, указыавет как они будут отрендерены на графике (доступны line, point), обязательно
#   keyFrom: 'dateFrom' # обязательно если typeChart - line
#   keyTo: 'dateTo' # обязательно если typeChart - line
#   data: [
#     level: 1 # На каком уровне по оси y будет отображаться
#     dateFrom: new Date()
#     dateTo: new Date()
#     label: "Пояснительный текст"
#   ,
#     ...
#   ]
# ,
#   name: 'orders'
#   typeChart: 'point'
#   keyValue: 'created_at'
#   data: [
#     level: 1
#     created_at: new Date()
#     label: "Пояснительный текст"
#   ,
#     ...
#   ]
# ]

# Rows требуется для выводя оси y
# [
#   level: 0
#   color: '#f15b19'
#   label: 'Aктивный'
# ,
#   level: 1
#   color: '#f3a113'
#   label: 'Новый / Вернувшийся'
# ,
#   level: 2
#   color: '#35ade8'
#   label: 'Остывший'
# ,
#   level: 3
#   color: '#a855a9'
#   label: 'Мертвый'
# ]

App.GanttChartComponent = Em.Component.extend
  classNames: ['gantt-chart']

  # Обязательные поля
  data: null                # Основной массив данных
  rows: null                # Массив фоновых горизонтальных колонок

  # Второстипенные
  width: 960
  height: 500

  marginTop: 0              # Отступы внутри графика
  marginRight: 0
  marginBottom: 34
  marginLeft: 0

  chartWidth: Ember.computed(
    'width',
    'marginRight',
    'marginLeft',
    ->
      width = @get('width') - @get('marginRight') - @get('marginLeft')

      if width < 0
        width = 0

      width
  )

  chartHeight: Ember.computed(
    'height',
    'marginTop',
    'marginBottom',
    ->
      height = @get('height') - @get('marginTop') - @get('marginBottom')

      if height < 0
        height = 0

      height
  )

  svgData: Ember.computed(
    'data',
    ->
      @get('data')
  )

  xScale: Ember.computed(
    'svgData'
    'chartWidth'
    ->
      svgData = @get('svgData')
      chartWidth = @get('chartWidth')

      minDate = null
      maxDate = null

      svgData.forEach (dataItem) ->
        if Ember.isArray(dataItem.data)
          dataItem.data.forEach (item) ->
            if minDate is null or +minDate > +item.dateFrom
              minDate = item.dateFrom

            if maxDate is null or +maxDate < +item.dateTo
              maxDate = item.dateTo

      d3.time.scale()
        .domain([minDate, maxDate])
        .rangeRound([35, chartWidth - 35])
        .nice(d3.time.day)
  )

  yScale: Ember.computed(
    'rows'
    'chartHeight'
    ->
      rows = @get('rows')
      chartHeight = @get('chartHeight')

      domain = rows.map((item, i) -> i)

      d3.scale.ordinal()
        .domain(domain)
        .rangeRoundBands([0, chartHeight])
  )

  xAxis: Ember.observer(
    'xScale',
    'svg',
    'chartHeight',
    Ember.on('svgReady', ->
      svg = @get('svg')
      xScale = @get('xScale')
      chartHeight = @get('chartHeight')

      domain = xScale.domain()
      minDate = domain[0]
      maxDate = domain[1]

      diff = moment(maxDate).diff(minDate)

      dates = [
        minDate,
        moment(minDate).add(diff * 0.25, 'milliseconds').toDate(),
        moment(minDate).add(diff * 0.5, 'milliseconds').toDate(),
        moment(minDate).add(diff * 0.75, 'milliseconds').toDate(),
        maxDate
      ]

      xAxis = d3.svg.axis()
        .scale(xScale)
        .orient("bottom")
        .tickFormat(d3.ru_RU.timeFormat('%d %B'))
        .tickValues(dates)

      # Обновляем существующий или создаем новый
      if svg.select(".x.axis").size()
        svg.select(".x.axis")
          .attr("transform", "translate(0,#{chartHeight + 10})")
          .call(xAxis)
      else
        xAxisEl = svg.append("g")
          .attr("class", "x axis")
          .attr("transform", "translate(0,#{chartHeight + 10})")
          .call(xAxis)
    )
  )

  renderPoint: (dataset) ->
    svg = @get('svg')
    rows = @get('rows')
    chartHeight = @get('chartHeight')
    xScale = @get('xScale')
    yScale = @get('yScale')
    key = dataset.keyValue || 'date'
    tip = @get('tip')

    halfHeight = chartHeight / rows.length / 2
    className = Ember.String.dasherize(dataset.name)

    unless svg.select(".#{className}").size()
      svg.append('g')
        .attr("class", "#{className}")

    elements = svg.select(".#{className}").selectAll(".element").data(dataset.data)

    # Update
    elements
      .attr("cx", (d) -> xScale(Ember.get(d, key)))
      .attr("cy", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("fill", (d) -> rows.findBy('level', Ember.get(d, 'level')).color)

    # Create
    elements.enter().append("circle")
      .attr("class", "element")
      .attr("cx", (d) -> xScale(Ember.get(d, key)))
      .attr("cy", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("r", 3)
      .attr("fill", (d) -> rows.findBy('level', Ember.get(d, 'level')).color)
      .on('mouseover', (d) -> unless Ember.isEmpty(Ember.get(d, 'label')) then tip.show(Ember.get(d, 'label')))
      .on('mouseout', tip.hide)

    # Delete
    elements
      .exit()
      .remove()

  renderLine: (dataset) ->
    svg = @get('svg')
    rows = @get('rows')
    chartHeight = @get('chartHeight')
    xScale = @get('xScale')
    yScale = @get('yScale')
    tip = @get('tip')
    keyFrom = dataset.keyFrom || 'dateFrom'
    keyTo = dataset.keyTo || 'dateTo'

    halfHeight = chartHeight / rows.length / 2
    className = Ember.String.dasherize(dataset.name)

    unless svg.select(".#{className}").size()
      svg.append('g')
        .attr("class", "#{className}")

    elements = svg.select(".#{className}").selectAll(".element").data(dataset.data)

    # Update
    elements
      .attr("x1", (d) -> xScale(Ember.get(d, keyFrom)) )
      .attr("y1", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("x2", (d) -> xScale(Ember.get(d, keyTo)))
      .attr("y2", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("stroke", (d) -> rows.findBy('level', Ember.get(d, 'level')).color)

    # Create
    elements.enter().append("line")
      .attr("class", "element")
      .attr("x1", (d) -> xScale(Ember.get(d, keyFrom)) )
      .attr("y1", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("x2", (d) -> xScale(Ember.get(d, keyTo)))
      .attr("y2", (d) -> yScale(Ember.get(d, 'level')) + halfHeight)
      .attr("stroke", (d) -> rows.findBy('level', Ember.get(d, 'level')).color)
      .on('mouseover', (d) -> unless Ember.isEmpty(Ember.get(d, 'label')) then tip.show(Ember.get(d, 'label')))
      .on('mouseout', tip.hide)

    # Delete
    elements
      .exit()
      .remove()

  renderData: Ember.observer(
    'svg',
    'rows',
    'svgData',
    'chartHeight',
    'xScale',
    'yScale',
    Ember.on('svgReady', ->
      svgData = @get('svgData')

      svgData.forEach (dataset) =>
        switch dataset.typeChart
          when "line"
            @renderLine(dataset)
          when "point"
            @renderPoint(dataset)
    )
  )

  renderRows: Ember.observer(
    'svg',
    'rows',
    'chartHeight',
    'yScale',
    Ember.on('svgReady', ->
      svg = @get('svg')
      rows = @get('rows')
      chartHeight = @get('chartHeight')
      yScale = @get('yScale')
      tip = @get('tip')

      height = chartHeight / rows.length

      # Join
      unless svg.select(".chart-rows").size()
        svg.append('g').attr("class", "chart-rows")

      chartRows = svg.select(".chart-rows").selectAll(".chart-row").data(rows)

      # Create
      newsChartRows = chartRows.enter().append("g")
        .attr("class", "chart-row")
        .attr("width", "100%")
        .attr("height", height)
        .attr("transform", (d) -> "translate(0,#{yScale(Ember.get(d, 'level'))})" )
        .on('mouseover', (d) -> unless Ember.isEmpty(Ember.get(d, 'label')) then tip.show(Ember.get(d, 'label')))
        .on('mouseout', tip.hide)

      newsChartRows.append("rect")
        .attr("class", "rect-background")
        .attr("width", "100%")
        .attr("height", height )
        .attr("fill", (d) -> Ember.get(d, 'color'))

      newsChartRows.append("line")
        .attr("class", "line-border-top")
        .attr("x1", "0")
        .attr("y1", height)
        .attr("x2", "100%")
        .attr("y2", height)

      newsChartRows.append("rect")
        .attr("class", "rect-border-left")
        .attr("width", 4)
        .attr("height", height )
        .attr("fill", (d) -> Ember.get(d, 'color'))
    )
  )

  svgObserver: Ember.observer(
    'width',
    'height',
    'chartWidth',
    'chartHeight',
    'marginLeft',
    'marginTop',
    'marginBottom',
    'marginRight',
    Ember.on('didInsertElement', ->
      width = @get('width')
      height = @get('height')

      chartWidth = @get('chartWidth')
      chartHeight = @get('chartHeight')

      marginLeft = @get('marginLeft')
      marginTop = @get('marginTop')
      marginBottom = @get('marginBottom')
      marginRight = @get('marginRight')

      # Главный контейнер
      svg = @get('svg')

      unless svg
        svg = d3.select(@$().get(0))
          .append("svg")

      svg
        .attr("width", width)
        .attr("height", height)

      if @get('svg')
        @set('svg', svg)
      else
        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset([-7, 0])
          .html((label) -> label)

        svg.call(tip)

        @set('tip', tip)
        @set('svg', svg)

        @trigger('svgReady')
    )
  )

  destroySvg: Ember.on('willDestroyElement', ->
    d3.select(@$('svg').get(0)).remove()
  )
